import { axiosInstance } from "../utils/axiosInterceptor";

export const customeronBoardingAction = async (
  formData,
  enqueueSnackbar,
  props
) => {
  const body = JSON.stringify(formData);
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axiosInstance.post("/users/onBoarding", body, config);
    enqueueSnackbar(`${res.data.message}`, { variant: "success" });
    console.log(res.data);
    props.history.push("/");
  } catch (err) {
    enqueueSnackbar(`Some error occurred`, { variant: "success" });
    console.log(err);
  }
};
